'use strict';/* global define */define('modules/ui/services/tree-graph-utils/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["TREE_GRAPH_SETTINGS", "_"];
function factory(TREE_GRAPH_SETTINGS,_){// jshint validthis:true
// jshint latedef:false
return{node:{addCTAtoNodeAndChildNodes:addCTAtoNodeAndChildNodes,getClasses:getClasses,getRootNode:getRootNode,hasChildren:hasChildren,hasDataChildren:hasDataChildren,isCta:isCta,isDisabled:isDisabled,isNotCta:isNotCta},svg:{getPath:getPath}};// ---
/**
     * Enrich the children of a given node with
     * cta-notes and there is none included in children collection
     *
     * @param {Object}           node  node
     * @param {Number|undefined} level level ( ONLY for RECURSIVE USAGE INTERNALLY )
     *
     * @tested
     */function addCTAtoNodeAndChildNodes(node,label,level){level=level||0;level++;// safety fix
// tree.nodes( rootNode );
// is fucking it up
var children=node.children||node._children||[];var hasCTAincluded=children.filter(function(kid){return kid.type==='cta';}).length;if(level<TREE_GRAPH_SETTINGS.MAX_LEVEL){children.forEach(function(kid){addCTAtoNodeAndChildNodes(kid,label,level);});}if(!hasCTAincluded&&node.type!=='cta'){children.push({name:label,children:[],type:'cta'});}}/**
     * Helper function to evaluate the needed classes in D3 context
     *
     * @param  {Object} d data node
     * @return {String}   class string
     *
     * @tested
     */function getClasses(d){var classes='c-treeGraph--node';if(d.type==='cta'){classes+=' is-cta';}if(d.loading){classes+=' is-loading';}if(hasChildren(d)){classes+=' has-children';}if(d.isActive){classes+=' is-active';}if(d._children&&d._children.length){classes+=' has-hidden-children';}return classes;}/**
     * Get the uppermost parent node of a given node
     *
     * @param  {Object} node node
     * @return {Object}      root node
     *
     * @tested
     */function getRootNode(node){if(!!node.parent){return getRootNode(node.parent);}return node;}/**
     * Evaluate if a given node has children holding actual
     * data - this means excluding the cta nodes
     *
     * @param  {Object}  d data node
     * @return {Boolean}   has data children
     *
     * @tested
     */function hasDataChildren(d){var children=d.children||d._children||[];return!!children.filter(function(kid){return kid.type!=='cta';}).length;}/**
     * D3 convinience function to check if a node should
     * be represented as disabled
     *
     * @param  {Object}  d data note
     * @return {Boolean}   is disabled
     *
     * @tested
     */function isDisabled(d){return!hasChildren(d)&&d.type!=='cta';}/**
     * d3 convience function to avoid anonymous functions
     *
     * @param  {Object}  d data node
     * @return {Boolean}   is not CTA
     */function isNotCta(d){return d.type!=='cta';}/**
     * d3 convience function to avoid anonymous functions
     *
     * @param  {Object}  d data node
     * @return {Boolean}   is CTA
     */function isCta(d){return d.type==='cta';}/**
     * Get the SVG path definition to connect to visual nodes
     *
     * @param  {Object} source source node
     * @param  {Object} target target node
     * @return {String}        path svg definition
     */function getPath(source,target){// special treatment for kick off animation
// where start and end point are basically the same
if(source.x===0&&source.y===0&&target.x===0&&target.y===0){return'M'+(source.x+TREE_GRAPH_SETTINGS.NODE.WIDTH/2)+','+(source.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT)+' '+'L'+(source.x+TREE_GRAPH_SETTINGS.NODE.WIDTH/2)+','+(source.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT)+' '+'L'+(source.x+TREE_GRAPH_SETTINGS.NODE.WIDTH/2)+','+(source.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT);}return'M'+(source.x+TREE_GRAPH_SETTINGS.NODE.WIDTH/2)+','+(source.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT)+' '+'L'+(source.x+TREE_GRAPH_SETTINGS.NODE.WIDTH/2)+','+(target.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT/2)+' '+'L'+target.x+','+(target.y+TREE_GRAPH_SETTINGS.NODE.HEIGHT/2);}/**
     * Evaluate if a node has either displayed or hidden children
     *
     * @param  {Object}  d data node
     * @return {Boolean}   has children
     *
     * @tested
     */function hasChildren(d){return!!(d.children&&d.children.length||d._children&&d._children.length);}}module.exports=factory;});
